/**
 * El periodo de las cifras: uno, el de arriba. Se recuerda; si no, Hoy.
 */
import { useCallback, useState } from 'react'

export const PERIODOS_PORTADA = [
    { clave: 'hoy', etiqueta: 'Hoy', dias: 1 },
    { clave: '7d', etiqueta: '7 días', dias: 7 },
    { clave: '30d', etiqueta: '30 días', dias: 30 },
] as const

export type PeriodoPortada = (typeof PERIODOS_PORTADA)[number]['clave']

export const CLAVE_PERIODO_PORTADA = 'agendify.portada.periodo'

export function esPeriodoPortada(v: string | null): v is PeriodoPortada {
    return v === 'hoy' || v === '7d' || v === '30d'
}

export function leerPeriodoPortada(): PeriodoPortada {
    try {
        const g = localStorage.getItem(CLAVE_PERIODO_PORTADA)
        if (esPeriodoPortada(g)) return g
    } catch {
        /* modo privado */
    }
    return 'hoy'
}

export function recordarPeriodoPortada(p: PeriodoPortada): void {
    try {
        localStorage.setItem(CLAVE_PERIODO_PORTADA, p)
    } catch {
        /* modo privado */
    }
}

export function diasDePeriodo(periodo: PeriodoPortada): number {
    return PERIODOS_PORTADA.find((p) => p.clave === periodo)?.dias ?? 1
}

/** En un demo, «Hoy» vacío no es el canal: los hilos suelen ser de ayer (025). */
export function periodoTrasSaberDemo(esDemo: boolean, actual: PeriodoPortada): PeriodoPortada {
    return esDemo && actual === 'hoy' ? '7d' : actual
}

export function usePeriodoPortada(): [PeriodoPortada, (p: PeriodoPortada) => void] {
    const [periodo, setPeriodo] = useState<PeriodoPortada>(leerPeriodoPortada)
    const elegir = useCallback((p: PeriodoPortada) => {
        setPeriodo(p)
        recordarPeriodoPortada(p)
    }, [])
    return [periodo, elegir]
}
